<kt-portlet class="kt-portlet--height-fluid w-100" #reportContainer>
  <h3 class="w-100 h-100 d-flex justify-content-center align-items-center" *ngIf="error">
    Что-то пошло не так, повторите попытку позже
  </h3>
</kt-portlet>
